export class Adresse {
  ligne1: string;
  ligne2?: string;
  ligne3?: string;
  codePostal?: string;
  ville?: string;
  pays?: string;

  constructor(
    ligne1: string,
    ligne2?: string,
    ligne3?: string,
    codePostal?: string,
    ville?: string,
    pays?: string,
  ) {
    this.ligne1 = ligne1;
    this.ligne2 = ligne2;
    this.ligne3 = ligne3;
    this.codePostal = codePostal;
    this.ville = ville;
    this.pays = pays;
  }
}